import { call, put, takeLatest } from "redux-saga/effects";
import * as actionTypes from "Redux/Actions/actionTypes";
import AddLoanRealEstate from "Communication/ApiClasses/AddLoanRealEstateRequest";
import {
  doLoadingStart,
  doLoadingFinish,
} from "Components/Common/ProgressIndicator/Actions/ProgressIndicatorActions";
import STRINGS from "Constants/Strings";

// worker
function* handleAddLoanRealEstate(action) {
  yield put(
    doLoadingStart(STRINGS.PROPERTY_DETAILS.API_KEYS.LOAN_ADD_REAL_ESTATE)
  );
  const addLoanRealEstate = new AddLoanRealEstate(
    action.data.applicationId,
    action.data.payLoad
  );
  try {
    const result = yield call(addLoanRealEstate.getData);
    yield put({
      type: actionTypes.LOAN_ADD_REAL_ESTATE_SUCCESS,
      response: result,
    });
    yield call(action.callback, result);
  } catch (e) {
    yield put({
      type: actionTypes.LOAN_ADD_REAL_ESTATE_ERROR,
      error: e.message,
    });
  } finally {
    yield put(
      doLoadingFinish(STRINGS.PROPERTY_DETAILS.API_KEYS.LOAN_ADD_REAL_ESTATE)
    );
  }
}

// watcher
function* addLoanRealEstateWatcherSaga() {
  yield takeLatest(actionTypes.LOAN_ADD_REAL_ESTATE, handleAddLoanRealEstate);
}

export default addLoanRealEstateWatcherSaga;
